import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="max-w-2xl mx-auto px-4 md:px-8 py-24 text-center" data-testid="payment-cancel-page">
      <i className="fas fa-circle-xmark text-5xl text-[#E619A8] mb-6"></i>
      <h1 className="font-heading font-black text-4xl">Pagamento <span className="text-[#E619A8]">annullato</span>.</h1>
      <p className="text-zinc-400 mt-3">Nessun addebito è stato effettuato.</p>
      <div className="mt-8 flex gap-3 justify-center">
        <Link to="/prezzi" className="px-6 py-3 rounded-md bg-[#FFBE00] text-black font-bold uppercase tracking-wider text-sm">Riprova</Link>
        <Link to="/dashboard" className="px-6 py-3 rounded-md border border-zinc-700 text-white text-sm uppercase">Dashboard</Link>
      </div>
    </div>
  );
}
